( function ( _s ) {
	_s.fn.fullWidthCtaCard = function () {
		return this.el.forEach( el => {
			const _fullWidthCtaCard = _s( el );
			const _cards = _fullWidthCtaCard.find( '.card' );

			_cards.on( 'click', e => {
				const _target = _s( e.target );
				const _card = _target.hasClass( 'card' ) ? _target : _target.closest( '.card' );

				if ( ! _target.hasClass( '.cta-button' ) ) {
					console.log( 'trigger click', _card.find( '.cta-button' ) );
					_card.find( '.cta-button' ).firstElement().click();
				}
			} );

			_cards.on( 'mouseenter', e => {
				const _target = _s( e.target );
				const _card = _target.hasClass( 'card' ) ? _target : _target.closest( '.card' );

				if ( ! _target.hasClass( '.cta-button' ) ) {
					_card.find( '.cta-button' ).addClass( 'hover' );
				}
			} );

			_cards.on( 'mouseleave', e => {
				const _target = _s( e.target );
				const _card = _target.hasClass( 'card' ) ? _target : _target.closest( '.card' );

				_card.find( '.cta-button' ).removeClass( 'hover' );
			} );
		} );
	};

	_s( document ).ready( () => {
		const _elements = _s( '.full-width-cta-card-module' );

		if ( _elements.length ) {
			_elements.fullWidthCtaCard();
		}
	} );
} )( window._s );
